import { routeData } from "@/router/constants/routes";
import { createAdyenCheckout, getSessionInfo } from "@/helpers/adyen-helper";
import { mapAdyenToFmgPaymentMethod, generateCcToken } from "@/helpers/adyen-helper";
import baseMixin from "@/mixins/base-mixin.js";
import { getPiaAuthorizationAmount } from "@/helpers/pricing-helper";
import store from "@/store";
import { storeActions } from "@/constants/store-actions";
import { submitWorkOrder } from "@/helpers/heritage-integration/order-helper.js";

export async function adyenReturnBeforeEnter(to, from) {
    console.log(`In adyen return.`);
    console.log(JSON.parse(JSON.stringify(to)));

    const sessionId = to?.query?.sessionId;
    const redirectResult = to?.query?.redirectResult;

    if (sessionId && redirectResult) {
        let result = null;

        try {
            result = await finalizeAdyenPayment(sessionId, redirectResult);
        } catch (unexpectedResult) {
            // If user cancelled payment, handle without error message
            if (unexpectedResult.code === "Cancelled" || unexpectedResult.code === "CANCEL") {
                return {
                    name: routeData.PAYMENT_ADYEN.name,
                    replace: true,
                };
            }

            // Otherwise, failure scenario.
            // Payment fails, so return user to payment-adyen screen to try again or pay later.
            return {
                name: routeData.PAYMENT_ADYEN.name,
                query: {
                    piaFailure: true,
                },
                replace: true,
            };
        }

        console.log(`Out of promise`);
        console.log(result);

        const sessionInfo = await getSessionInfo(sessionId, result.sessionResult);

        console.log(`Got session info:`);
        console.log(sessionInfo);

        // TODO once afterpay info is returned, create cc token and submit order.
        const paymentMethod = mapAdyenToFmgPaymentMethod(sessionInfo?.paymentMethod);
        const authorizationAmount = getPiaAuthorizationAmount(store.getters.order.lineItems);
        const ccToken = generateCcToken(sessionInfo);

        ccToken.authCode = "831001";
        ccToken.cardType = "VS";
        ccToken.lastFour = "1111";
        ccToken.expMonth = "03";
        ccToken.expYear = "2030";

        await baseMixin.methods.dispatchStoreAction(
            storeActions.SAVE_PAYMENT_METHOD_CHOICE,
            paymentMethod,
            false
        );

        await baseMixin.methods.dispatchStoreAction(storeActions.SAVE_CCTOKEN, ccToken, false);

        await baseMixin.methods.dispatchStoreAction(
            storeActions.SAVE_NEXTGEN_SETTLED_AMOUNT,
            authorizationAmount,
            false
        );

        await baseMixin.methods.dispatchStoreAction(
            storeActions.SAVE_AUTHORIZATION_AMOUNT,
            authorizationAmount,
            false
        );

        await baseMixin.methods.dispatchStoreAction(storeActions.RESET_SAVE_SESSION_PROMISE);

        try {
            await submitWorkOrder({
                pageNameToLog: "adyen-return",
                submitAfterSave: true,
            });
        } catch (error) {
            console.log(error);
            return {
                name: routeData.PAYMENT_METHOD.name,
                query: {
                    piaError: "true",
                },
                replace: true,
            };
        }

        await baseMixin.methods.dispatchStoreAction(storeActions.CREATE_SUBMITTED_STATE);

        return {
            name: routeData.CONFIRMATION.name,
            replace: true,
        };
    }

    return {
        name: routeData.ERROR.name,
        replace: true,
    };
}

function finalizeAdyenPayment(sessionId, redirectResult) {
    return new Promise((resolve, reject) => {
        createAdyenCheckout({
            session: {
                id: sessionId,
            },
            handlers: {
                onPaymentCompleted: (result, component) => {
                    console.log(`Payment successful`);
                    console.log(result);
                    resolve(result);
                },
                onPaymentFailed: (result, component) => {
                    console.log(`Payment failed`);
                    console.log(result);

                    if (result?.resultCode !== "Cancelled") {
                        const stringToLog = `ADYEN PAYMENT NOT AUTHORIZED. Code = ${result?.resultCode}. Id = ${sessionId}`;

                        global.$logger.logError(stringToLog);
                    }

                    reject({
                        code: result?.resultCode,
                        message: "Payment failed from Adyen",
                    });
                },
                onError: (error, component) => {
                    console.log(`Error occured`);
                    console.log(error);

                    if (error?.name !== "CANCEL") {
                        const stringToLog = `ADYEN ERROR. Name = ${error?.name}. Details = ${error?.message}.`;

                        global.$logger.logError(stringToLog);
                    }

                    reject({
                        code: error?.name,
                        message: "Error from Adyen",
                    });
                },
            },
            options: {},
        }).then(
            (checkout) => {
                checkout.submitDetails({
                    details: {
                        redirectResult: redirectResult,
                    },
                });
            },
            (error) => {
                reject(error);
            }
        );
    });
}
